import React from 'react';
import { Save, X } from 'lucide-react';

interface Props {
  isSaving: boolean;
  onSave: () => void;
  onSkip: () => void;
  onClose: () => void;
}

const SaveCardPrompt: React.FC<Props> = ({ isSaving, onSave, onSkip, onClose }) => {
  return (
    <div className="fixed inset-0 z-100 flex items-center justify-center p-4 bg-black/40 backdrop-blur-sm">
      <div className="bg-white rounded-card shadow-elevated w-full max-w-md overflow-hidden">
        <div className="flex items-start justify-between px-5 py-4 border-b border-zinc-100">
          <div className="flex items-center gap-3">
            <div className="w-9 h-9 rounded-btn bg-brand-50 flex items-center justify-center">
              <Save className="w-4 h-4 text-brand-500" />
            </div>
            <div>
              <h3 className="font-display font-semibold text-foreground">Save this resume as a card?</h3>
              <p className="text-sm text-secondary-foreground mt-0.5">
                This resume isn&apos;t saved to your dashboard yet.
              </p>
            </div>
          </div>
          <button
            onClick={onClose}
            disabled={isSaving}
            className="w-8 h-8 flex items-center justify-center text-zinc-400 hover:text-foreground rounded-btn hover:bg-zinc-50 transition-colors disabled:opacity-50"
            aria-label="Close"
          >
            <X className="w-4 h-4" />
          </button>
        </div>

        <div className="px-5 py-4 flex items-center justify-end gap-3">
          <button
            onClick={onSkip}
            disabled={isSaving}
            className="h-10 px-5 text-sm text-zinc-600 hover:text-foreground transition-colors font-medium bg-transparent border border-muted rounded-btn disabled:opacity-50"
          >
            Don&apos;t Save
          </button>
          <button
            onClick={onSave}
            disabled={isSaving}
            className="h-10 px-5 bg-brand-500 hover:bg-brand-600 disabled:opacity-50 disabled:cursor-not-allowed text-white text-sm font-medium rounded-btn transition-colors inline-flex items-center gap-2"
          >
            <Save className="w-4 h-4" />
            {isSaving ? 'Saving...' : 'Save as card'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SaveCardPrompt;
